import React from "react";
import "./ProfileCard.css";
import { BsFillPeopleFill, BsFillEyeFill } from "react-icons/bs";

function ProfileCard({ name, followers, profileURL, views }) {
  return (
    <div className="card-container">
      <a href={profileURL} target="_blank" rel="noreferrer">
        <h1 className="bold-text">{name}</h1>
      </a>
      <div className="social-container">
        <div className="followers">
          <h1 className="bold-text">{followers}</h1>

          <BsFillPeopleFill />
          <h2 className="smaller-text">Followers</h2>
        </div>
        <div className="views">
          <h1 className="bold-text">{views}</h1>

          <BsFillEyeFill />
          <h2 className="smaller-text">Views</h2>
        </div>
      </div>
    </div>
  );
}

export default ProfileCard;
